import baseEditForm from 'formiojs/components/number/Number.form';

import ForceRequiredField from '../../../configuration-components/force-required/force-required';
import OriginalLabel from '../../../configuration-components/base-widget-configuration/display/original-label';
import BaseEditConditionalComponents from '../../../configuration-components/base-widget-configuration/base.edit.conditional.components';
import { BaseEditData } from '../../../configuration-components/base-widget-configuration/data/base.edit.data';
import LenderOnly from '../../../configuration-components/base-widget-configuration/display/lender-only-field-checkbox';
import BaseEditScriptComponents from '../../../configuration-components/base-widget-configuration/base.edit.script.components';
// eslint-disable-next-line max-lines-per-function
export default function (...extend: any[]) {
	let form = baseEditForm(
		[
			{
				key: 'api',
				ignore: true
			},
			{
				key: 'logic',
				ignore: true
			},
			{
				key: 'display',
				components: [OriginalLabel, LenderOnly]
			},
			new BaseEditData().getTab({
				components: {
					defaultComponents: [
						{
							key: 'decimalLimit',
							ignore: true
						},
						{
							key: 'inputFormat',
							ignore: true
						}
					]
				}
			}),
			{
				key: 'validation',
				components: ForceRequiredField
			},
			{
				key: 'conditional',
				components: BaseEditConditionalComponents
			},
			{
				label: 'Script AI',
				key: 'scriptAi',
				weight: 100,
				components: BaseEditScriptComponents,
			},
			{
				key: 'layout',
				ignore: true
			}
		],
		...extend
	);

	return form;
}
